var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { F as FaceDirectionEnum } from "./enums-86f58524.js";
import { type, defaultValue, Component, Schema } from "./decorators/type.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let SpineSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "frame");
    __publicField(this, "spineKey");
    __publicField(this, "skin");
    __publicField(this, "currentAnimation");
    __publicField(this, "animationSpeed");
    __publicField(this, "faceDirection");
    __publicField(this, "scale");
    __publicField(this, "xscale");
    __publicField(this, "yscale");
    __publicField(this, "initialScale");
    __publicField(this, "rotation");
    __publicField(this, "xoffset");
    __publicField(this, "yoffset");
    __publicField(this, "zIndex");
    __publicField(this, "opacity");
    __publicField(this, "anchorX");
    __publicField(this, "anchorY");
    __publicField(this, "antiJitterTime");
  }
};
__decorateClass([
  type("number"),
  defaultValue(0)
], SpineSchema.prototype, "frame", 2);
__decorateClass([
  type("string")
], SpineSchema.prototype, "spineKey", 2);
__decorateClass([
  type("string")
], SpineSchema.prototype, "skin", 2);
__decorateClass([
  type("string")
], SpineSchema.prototype, "currentAnimation", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpineSchema.prototype, "animationSpeed", 2);
__decorateClass([
  type("number"),
  defaultValue(FaceDirectionEnum.NONE)
], SpineSchema.prototype, "faceDirection", 2);
__decorateClass([
  type("number"),
  defaultValue(1)
], SpineSchema.prototype, "scale", 2);
__decorateClass([
  type("number")
], SpineSchema.prototype, "xscale", 2);
__decorateClass([
  type("number")
], SpineSchema.prototype, "yscale", 2);
__decorateClass([
  type("number"),
  defaultValue(1)
], SpineSchema.prototype, "initialScale", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpineSchema.prototype, "rotation", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpineSchema.prototype, "xoffset", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpineSchema.prototype, "yoffset", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpineSchema.prototype, "zIndex", 2);
__decorateClass([
  type("number"),
  defaultValue(1)
], SpineSchema.prototype, "opacity", 2);
__decorateClass([
  type("number"),
  defaultValue(0.5)
], SpineSchema.prototype, "anchorX", 2);
__decorateClass([
  type("number"),
  defaultValue(0.5)
], SpineSchema.prototype, "anchorY", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpineSchema.prototype, "antiJitterTime", 2);
SpineSchema = __decorateClass([
  Component("Spine")
], SpineSchema);
const __vite_glob_0_29 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get SpineSchema() {
    return SpineSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  SpineSchema as S,
  __vite_glob_0_29 as _
};
//# sourceMappingURL=Spine-11fceea9.js.map
